// Distinct editorial thumbnails per sub-service code.
// Sourced from Unsplash editorial photos (free use under Unsplash License).
// Each URL is unique so no two cards in a module share an image.
// If a URL 404s, ServicePage/SubServicePage render a graceful dark fallback.

const U = (id) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=1000&q=70`;

export const SERVICE_IMAGES = {
  // 01 · Book Publishing
  "01.1": U("1544947950-fa07a98d237f"), // colourful open books on a shelf
  "01.2": U("1455390582262-044cdead277a"), // black & white typewriter
  "01.3": U("1516280440614-37939bbacd81"), // headphones + book (audio edition)

  // 02 · Marketing (non-logo cards; 02.1 D2C Ads & 02.6 Amazon Ads use logo containers)
  "02.2": U("1467232004584-a241de8bcf5d"), // laptop showing landing page
  "02.3": U("1611095973362-88e8e2557e58"), // designer moodboard flat lay
  "02.4": U("1495020689067-958852a7765e"), // newspaper stack (PR)
  "02.5": U("1512820790803-83ca734da794"), // wrapped gift + books (giveaway)
  "02.7": U("1607083206869-4c7672e72a8a"), // packages on a truck (quick commerce)
  "02.8": U("1521056787327-165eb2a35a02"), // bookstore endcap
  "02.9": U("1526304640581-d334cdbbf45e"), // world map / globe (international)
  "02.10": U("1519671482749-fd09be7ccebf"), // event stage with mic (book launch)
  "02.11": U("1522204523234-8729aa6e3d5f"), // reviewer with book + phone
  "02.12": U("1502920917128-1aa500764cbd"), // creator with phone
  "02.13": U("1516979187457-637abb4f9353"), // bookmark tucked in a book
  "02.14": U("1596526131083-e8c633c948d2"), // envelopes / email letters
  "02.15": U("1512428559087-560fa5ceab42"), // hand holding phone (whatsapp)
  "02.16": U("1504711434969-e33886168f5c"), // folded newspaper (hyperlocal)

  // 03 · Printing
  "03.1": U("1497633762265-9d179a990aa6"), // printing press / stacked books

  // 04 · Distribution
  "04.1": U("1580618672591-eb180b1a973f"), // delivery scooter / rider
  "04.2": U("1611606063065-ee7946f0787a"), // Amazon-style parcel stack
  "04.3": U("1607082349566-187342175e2f"), // marketplace boxes / logistics
  "04.4": U("1592496001020-d31bd830651f"), // Kindle / e-reader tablet
  "04.5": U("1556742049-0cfed4f6a45d"), // e-commerce site on laptop (D2C)
  "04.6": U("1524578271613-d550eacf6090"), // wooden bookshelves (bookstores)
  "04.7": U("1519677100203-a0e668c92439"), // NYC skyline (US)
  "04.8": U("1513635269975-59663e0ac1ad"), // London / Big Ben (UK)
  "04.9": U("1512453979798-5ea266f8880c"), // Dubai / Burj Khalifa (UAE)

  // 05 · Audiobooks
  "05.1": U("1611532736597-de2d4265fba3"), // AI voice / synth waveform
  "05.2": U("1584680226833-0d680d0a0794"), // narrator at studio mic (\u2264 5 hrs)
  "05.3": U("1590602847861-f357a9332bbc"), // full studio session mic (> 5 hrs)
  "05.4": U("1571330735066-03aaa9429d89"), // headphones on world map (distribution)
};

export function imageForSub(code, fallback) {
  return SERVICE_IMAGES[code] || fallback || null;
}
